import TitleUpdater from '../../../components/common/TitleUpdater';
import { Footer, TitleBar } from '../../../components';
import GenericListManager from '../../../components/generic/ListManager/GenericListManager';
import {
  GET_LOCATIONS_CYBER_MODULE,
  SET_LOCATIONS_CYBER_MODULE,
} from './queries';

import { Location } from '../../exposure/dependency/DependencyMatrix';
import { RemoveLocationsModal } from '../components/RemoveLocationsModal';
import { useFetchSelectedLocations, useRemoveLocationConfirmation } from './hooks';

const LocationLevelSelection = () => {
  const allFilterFn = (item: Location) => !item.cyberSelected;
  const selectedFilterFn = (item: Location) => item.cyberSelected;

  const { data: locations } = useFetchSelectedLocations();

  const {
    isModalOpen,
    affectedLocations,
    handleBeforeUpdate,
    handleConfirm,
    handleCancel,
  } = useRemoveLocationConfirmation(locations ?? []);

  return (
    <>
      <TitleUpdater title="Location Application Mapping" />
      <TitleBar
        title="Location Application Mapping"
        subtitle="Location Selection"
        brief="Select which Locations you'd like to include in the Cyber mapping. If a location is missing, it needs to be added in the data inputs section."
      />
      <GenericListManager
        addedTitle="Locations Added"
        availableTitle="Locations Available"
        fetchAllQuery={{
          query: GET_LOCATIONS_CYBER_MODULE,
          identifier: 'findAllLocations',
          filterFn: allFilterFn,
        }}
        fetchSelectedQuery={{
          query: GET_LOCATIONS_CYBER_MODULE,
          identifier: 'findAllLocations',
          filterFn: selectedFilterFn,
        }}
        itemKey="uuid"
        itemLabel="locationName"
        updateMutation={{
          mutation: SET_LOCATIONS_CYBER_MODULE,
        }}
        refetchQueries={[
          {
            query: GET_LOCATIONS_CYBER_MODULE,
          },
        ]}
        beforeUpdate={(items) => {
          return new Promise((resolve) => {
            handleBeforeUpdate(items, () => resolve(true));
          });
        }}
      />
      <Footer backPath={'/cyber/location-level/list'} />
      <RemoveLocationsModal
        isOpen={isModalOpen}
        onCancel={handleCancel}
        onRemove={handleConfirm}
        locations={affectedLocations}
      />
    </>
  );
};

export default LocationLevelSelection;
